import type { FavoriteListEntityDto } from '@/gen/bff'
import type { FavoriteMultipleListItemSchema } from '@/schemas/favoriteMultipleListItemSchema'

export const favoriteItemConverter = (item: FavoriteListEntityDto): FavoriteMultipleListItemSchema => ({
  id: item.id ?? '',
  name: item.name ?? '',
  customerId: item.customerId ?? '',
  isDefault: item.isDefault ?? false,
  createdBy: item.createdBy ?? null,
  createdByUsername: item.createdByUsername ?? null,
  creationDate: item.creationDate ?? null,
  lastModifiedBy: item.lastModifiedBy ?? '',
  lastModifiedByUsername: item.lastModifiedByUsername ?? '',
  lastModifiedDate: item.lastModifiedDate ?? null,
})
